











import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import Login from './Login.vue'
const auth = namespace('auth')

@Component({ components: { Login } })
export default class Auth extends Vue {
  @auth.Getter authenticated!: boolean
  @auth.Action login!: () => void
}
